var $ = jQuery;

export function init() {

  function issueBreakerAnim() {

    var tlBreakerAnim = new TimelineLite;

    // Animation sequence
    tlBreakerAnim.from($('.issue-breaker__border-eyebrow'), .8, {alpha: 0, scaleX: 0}, 'label');
    tlBreakerAnim.from($('.issue-breaker__eyebrow'), .7, {y: 30}, 'label+=.2');
    tlBreakerAnim.from($('.issue-breaker__title-text'), .7, {y: 30}, 'label+=.3');
    tlBreakerAnim.from($('.issue-breaker__description'), .7, {y: 30}, 'label+=.4');
    tlBreakerAnim.from($('.issue-breaker__button'), .7, {y: 30}, 'label+=.5');
    tlBreakerAnim.from($('.issue-breaker__border'), .7, {y: 40}, 'label+=.5');
    tlBreakerAnim.from($('.issue-breaker__image'), 1.4, {scale: 1.2}, 'label+=.6'); // Image
    tlBreakerAnim.from($('.issue-breaker__report-tout'), .5, {y: 60}, 'label+=.7');
    tlBreakerAnim.from($('.issue-breaker__title-arrow'), .5, {alpha: 0}, 'arrow');
    tlBreakerAnim.to($('.issue-breaker__title-arrow'), .3, {alpha: 0}, 'arrow+=2');
    tlBreakerAnim.to($('.issue-breaker__title-arrow'), .3, {alpha: 1}, 'arrow+=2.3');
    tlBreakerAnim.to($('.issue-breaker__title-arrow'), .3, {alpha: 0}, 'arrow+=2.6');
    tlBreakerAnim.to($('.issue-breaker__title-arrow'), .3, {alpha: 1}, 'arrow+=2.9');
  }
  issueBreakerAnim();

}
